import { render, staticRenderFns } from "./NoPermission.vue?vue&type=template&id=4989a750&scoped=true&"
var script = {}
import style0 from "./NoPermission.vue?vue&type=style&index=0&id=4989a750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989a750",
  null
  
)

export default component.exports